import React, { useContext, useEffect, useState } from 'react'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { BufferService } from 'src/components/M_Components'
import { useTranslation } from "react-i18next"
import { LoadingContext } from 'src/components/M_Components'

export default function ChangeLogPage() {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState('')
    const [dataChangeLog, setDataChangeLog] = useState([])
    const bufferServiceChangeLog = new BufferService('logChange')
    const ctx = useContext(LoadingContext)

    useEffect(() => {
        ctx.setIsLoad(true)
        bufferServiceChangeLog.get().then((response) => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', 'Error opening Change Log page', '')
                ctx.setIsLoad(false)
                return
            }
            setDataChangeLog(response.Items)
            ctx.setIsLoad(false)
        })
    }, [])

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false)
    }

    function toJSONLocal(date) {
        return date.slice(0, 10)
    }

    function reformatDate(dateStr) {
        var dArr = dateStr.split("-")  // ex input: "2010-01-18"
        return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) //ex output: "18/01/2010"
    }


    return (
        <>
            <div className='divAccordion'>
                {dataChangeLog.map((value, index) => {
                    return (
                        <MuiAccordion disableGutters elevation={1} key={index} square expanded={expanded === `'panel '${index}`} onChange={handleChange(`'panel '${index}`)} >
                            <MuiAccordionSummary
                                aria-controls="panel1d-content" id="panel1d-header"
                                expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
                                sx={{
                                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(90deg)', },
                                    '& .MuiAccordionSummary-content': { marginLeft: '20px', },
                                    flexDirection: 'row-reverse',
                                }}
                            >
                                <p style={{ color: 'var(--color-blue)', fontWeight: 'bold' }}>{t("LabelUpdateDate")}{reformatDate(toJSONLocal(value.CreatedOn))}</p>
                            </MuiAccordionSummary>
                            <MuiAccordionDetails sx={{ borderTop: '1px solid var(--color-grey)', borderBottom: '1px solid var(--color-grey)', padding: '20px', }} >
                                <div className='mainDiv'>
                                    {value.LogFeatureList.map((val, key) => {
                                        return (
                                            <div className='midleDiv' key={key}>
                                                <div className='spanKey'>
                                                    <span className='logSpanTitle' style={{ backgroundColor: val.Color }}>{val.Feature}</span>
                                                </div>
                                                <div className='spanValue'>
                                                    <span className='textTransform'>{val.Description}</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </MuiAccordionDetails>
                        </MuiAccordion>
                    )
                })}
            </div>
            <br /><br /><br /><br /><br />
        </>
    )
}